import React from 'react';

const Home = React.lazy(() => import('../Screens/Main/Home'));
const Price = React.lazy(() => import('../Screens/Main/Price'));
const News = React.lazy(() => import('../Screens/Main/News'));
const Charts = React.lazy(() => import('../Screens/Charts/index'));
const Subscription = React.lazy(() => import('../Screens/Subscription/index'));
const SubscriptionDetails = React.lazy(() => import('../Screens/Subscription/SubscriptionDetails'));
const Login = React.lazy(() => import('../Screens/Out/Login'))


export const routes = [
  {
    path: "/home",
    name: "صفحه اصلی",
    component: Home,
  },
  {
    path: "/price",
    name: "آرشیو قیمت ها",
    component: Price,
  },
  {
    path: "/news",
    name: "آخرین اخبار",
    component: News,
  },
  {
    path: "/charts",
    name: "نمودارها",
    component: Charts,
  },
  {
    path: "/subscription",
    name: "اشتراک",
    component: Subscription,
  },
  {
    path: "/subscriptionDetails",
    name: "جزییات",
    component: SubscriptionDetails,
  },
  // {
  //   path: "/login",
  //   name: "",
  //   component: Login,
  // },
];

